<template>
    <div>
        <HeaderCard imageLogo="imageLogo" />
        <b-card>
            <div>
                <b-row>
                    <b-col>
                        <h4>FORM REGISTRASI NPBU</h4>
                        <em
                            >Silahkan isi form di bawah ini dengan data yang
                            valid.</em
                        >
                    </b-col>
                    <b-col>
                        <div class="float-right" v-if="user.npbu_id">
                            <span class="font-weight-bold"
                                >STATUS REGISTRASI:
                            </span>
                            <span class="h4">
                                <span class="label label-warning">
                                    {{ Npbu.status_regis.nama }}
                                </span>
                            </span>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="py-3">
                <b-card>
                    <div class="nav-wizards-container">
                        <nav class="nav nav-wizards-1 mb-2">
                            <!-- completed -->
                            <div class="nav-item col">
                                <b-nav
                                    :class="{
                                        'nav-link': true,
                                        completed: profil
                                    }"
                                    href="#"
                                >
                                    <div class="nav-no">1</div>
                                    <div class="nav-text">
                                        PROFIL BADAN USAHA
                                    </div>
                                </b-nav>
                            </div>

                            <!-- active -->
                            <div class="nav-item col">
                                <b-nav
                                    :class="{
                                        'nav-link': true,
                                        completed: pimpinan
                                    }"
                                    href="#"
                                >
                                    <div class="nav-no">2</div>
                                    <div class="nav-text">
                                        PIMPINAN
                                    </div>
                                </b-nav>
                            </div>

                            <!-- disabled -->
                            <div class="nav-item col">
                                <b-nav
                                    :class="{
                                        'nav-link': true,
                                        completed: penanggung_jawab
                                    }"
                                    href="#"
                                >
                                    <div class="nav-no">3</div>
                                    <div class="nav-text">
                                        PENANGGUNG JAWAB
                                    </div>
                                </b-nav>
                            </div>
                            <!-- <div class="nav-item col">
                                <b-nav
                                    :class="{
                                        'nav-link': true,
                                        completed: selesai
                                    }"
                                    href="#"
                                >
                                    <div class="nav-no">
                                        <i class="fa fa-check"></i>
                                    </div>
                                    <div class="nav-text">
                                        Selesai
                                    </div>
                                </b-nav>
                            </div> -->
                        </nav>
                    </div>
                </b-card>
            </div>
            <div v-if="user.npbu_id && (Npbu.status_regis.id !== 5)">
                <b-alert variant="warning" show class="text-center font-weight-bold">
                    Data anda kini masih dalam proses <em class="text-danger">"{{ Npbu.status_regis.nama }}"</em>. Silahkan cek atau periksa kembali data yang telah anda masukkan.
                </b-alert>
            </div>
            <div class="pt-2">
                <b-card>
                    <router-view></router-view>
                </b-card>
            </div>
        </b-card>
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import HeaderCard from "@/components/header/HeaderCard.vue";
import { mapState } from "vuex";

export default {
    components: {
        HeaderCard
    },
    data() {
        return {
            profil: true,
            pimpinan: false,
            penanggung_jawab: false,
            selesai: false,
            user: JSON.parse(localStorage.getItem("user"))
        };
    },
    created() {
        // if (JSON.parse(localStorage.getItem("selesai"))) {
        //     this.statusSelesai();
        // } else {
        this.stepClass();
        // }
    },
    watch: {
        $route(to, from) {
            // if (JSON.parse(localStorage.getItem("selesai"))) {
            //     this.statusSelesai();
            // } else {
                // localStorage.setItem("selesai", false);
            this.stepClass();
            // }
        }
    },
    computed: {
        ...mapState(["Npbu"])
    },
    methods: {
        // step
        stepClass() {
            switch (this.$route.name) {
                case "Profil":
                    this.profil = true;
                    this.pimpinan = false;
                    this.penanggung_jawab = false;
                    break;
                case "Pimpinan":
                    this.pimpinan = true;
                    this.profil = true;
                    this.penanggung_jawab = false;
                    break;
                case "PenanggungJawab":
                    this.penanggung_jawab = true;
                    this.profil = true;
                    this.pimpinan = true;
                    break;
                default:
                    this.pimpinan = false;
                    this.penanggung_jawab = false;
                    this.profil = false;
            }
        },
        // setelah selesai kirim permohonan
        statusSelesai() {
            this.penanggung_jawab = true;
            this.pimpinan = true;
            this.profil = true;
            this.selesai = true
        }
    }
};
</script>
